import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message", "dontAskAgain", "dontAskAgainContainer"]
  static values = {
    prompt: String,
    allowSkip: { type: Boolean, default: true },
    confirmKey: String
  }

  connect() {
    console.log("confirm-modal controller connected")
  }

  // Called when a button/link with this controller is clicked
  async handleClick(event) {
    event.preventDefault()
    event.stopPropagation()

    const element = event.currentTarget
    const prompt = element.dataset.confirmPrompt || this.promptValue || "Are you sure?"
    const allowSkip = element.dataset.confirmAllowSkip !== "false"

    // Generate confirm key
    let confirmKey = element.dataset.confirmKey || ""
    if (!confirmKey) {
      if (element.href) {
        confirmKey = element.href
      } else if (element.form) {
        confirmKey = element.form.action
      } else {
        confirmKey = window.location.pathname
      }
    }

    // Check if user previously selected "don't ask again"
    const skipConfirm = localStorage.getItem(`confirm_skip_${confirmKey}`)
    if (skipConfirm === "true") {
      this.proceedWithAction(element)
      return
    }

    // Show the confirmation modal
    const confirmed = await this.showConfirmModal(prompt, confirmKey, allowSkip)

    if (confirmed) {
      this.proceedWithAction(element)
    }
  }

  proceedWithAction(element) {
    if (element.form) {
      // It's a submit button - submit the form
      element.form.requestSubmit(element)
    } else if (element.href) {
      // It's a link - navigate to it
      window.location.href = element.href
    }
  }

  async showConfirmModal(message, confirmKey, allowSkip = true) {
    const modal = document.getElementById("confirm-modal-singleton")
    if (!modal) {
      console.error("Confirm modal element not found")
      return window.confirm(message)
    }

    const messageTarget = modal.querySelector('[data-confirm-modal-target="message"]')
    const dontAskAgainContainer = modal.querySelector('[data-confirm-modal-target="dontAskAgainContainer"]')
    const dontAskAgainCheckbox = modal.querySelector('[data-confirm-modal-target="dontAskAgain"]')

    if (messageTarget) {
      messageTarget.textContent = message
    }

    // Show/hide "don't ask again" checkbox
    if (dontAskAgainContainer) {
      if (allowSkip) {
        dontAskAgainContainer.classList.remove("hidden")
        if (dontAskAgainCheckbox) {
          dontAskAgainCheckbox.checked = false
        }
      } else {
        dontAskAgainContainer.classList.add("hidden")
      }
    }

    modal.classList.remove("hidden")

    return new Promise((resolve) => {
      // Store confirmKey for later use
      modal.dataset.currentConfirmKey = confirmKey

      // Set up one-time event listeners
      const confirmHandler = () => {
        if (dontAskAgainCheckbox && dontAskAgainCheckbox.checked && confirmKey) {
          localStorage.setItem(`confirm_skip_${confirmKey}`, "true")
        }
        modal.classList.add("hidden")
        cleanup()
        resolve(true)
      }

      const cancelHandler = () => {
        modal.classList.add("hidden")
        cleanup()
        resolve(false)
      }

      const cleanup = () => {
        confirmBtn.removeEventListener("click", confirmHandler)
        cancelBtn.removeEventListener("click", cancelHandler)
      }

      const confirmBtn = modal.querySelector('[data-action="click->confirm-modal#confirm"]')
      const cancelBtn = modal.querySelector('[data-action="click->confirm-modal#cancel"]')

      if (confirmBtn) confirmBtn.addEventListener("click", confirmHandler)
      if (cancelBtn) cancelBtn.addEventListener("click", cancelHandler)
    })
  }
}

